import numberToFixed from './numberToFixed'

export default function calcPercentage(partial: number, total: number) {
  return Math.min(numberToFixed((100 * partial) / total, 2), 100)
}
